const MEGABYTE_FORMAT = new Intl.NumberFormat('en-GB', {
  style: 'unit',
  unit: 'megabyte',
  unitDisplay: 'short',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const KILOBYTE_FORMAT = new Intl.NumberFormat('en-GB', {
  style: 'unit',
  unit: 'kilobyte',
  unitDisplay: 'short',
  maximumFractionDigits: 0,
});

/** Decimal units, as the old media center counted them (1 MB = 1,000,000 bytes). */
const BYTES_PER_KILOBYTE = 1000;
const BYTES_PER_MEGABYTE = 1000 * 1000;

/** Bytes in MB with one decimal, for example "0.6 MB". */
export function formatMegabytes(bytes: number): string {
  return MEGABYTE_FORMAT.format(Math.max(0, bytes) / BYTES_PER_MEGABYTE);
}

/** Bytes below 1 MB in kB without decimals, from 1 MB on in MB with one decimal. */
export function formatFileSize(bytes: number): string {
  if (bytes < BYTES_PER_MEGABYTE) {
    return KILOBYTE_FORMAT.format(
      Math.max(1, Math.round(bytes / BYTES_PER_KILOBYTE))
    );
  }

  return formatMegabytes(bytes);
}
